import { useCallback, useEffect, useState } from 'react';

import routeDefinitions from 'enum/routeDefinitions';
import ProfileStore from 'stores/ProfileStore';
import { getEventCams } from 'pages/Directory/EventSegment/api';

import { FeedsCarouselStream } from './types';


const POLLING_INTERVAL = 60_000;

const useFeedsCarousel = () => {
  const { profileName, realityShow } = ProfileStore;

  const directoryTag: string = realityShow?.directoryTag || '';
  const currentUserName = String(profileName).toLowerCase();

  const [streams, setStreams] = useState<FeedsCarouselStream[]>([]);

  const loadStreams = useCallback(async() => {
    if (!directoryTag) {
      setStreams([]);

      return;
    }

    try {
      const result = await getEventCams(directoryTag);
      const streamsReceived = result?.users || [];

      const filtered = streamsReceived.filter(
        (item: FeedsCarouselStream) => String(item.username).toLowerCase() !== currentUserName
      ).map((item: FeedsCarouselStream) => {
        const user = item.username.toLowerCase();
        const routerUrl = routeDefinitions.get(routeDefinitions.profileV2.root, { user });

        return { ...item, routerUrl };
      });

      setStreams(filtered);
      ProfileStore.setEventCams(streamsReceived);
    } catch {
      setStreams([]);
    }
  }, [
    directoryTag,
    currentUserName,
  ]);

  useEffect(() => {
    let timer: ReturnType<typeof setTimeout> = null;

    const loadHandler = () => {
      if (timer) {
        clearTimeout(timer);
      }

      loadStreams();

      timer = setTimeout(loadHandler, POLLING_INTERVAL);
    };

    loadHandler();

    return () => {
      clearTimeout(timer);
    };
  }, [loadStreams]);

  return { streams };
};

export default useFeedsCarousel;
